var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaverateblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.18457 0.375V20.5L1.5791 19.4609L8.05957 14.5938L14.54 19.4609L15.9346 20.5V0.375H0.18457ZM1.93457 2.125H14.1846V17L8.5791 12.7891L8.05957 12.4062L7.54004 12.7891L1.93457 17V2.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaverateblack);
export default __webpack_public_path__ + "static/media/faverateblack.bd733b5906d548277424bafbc2a816ea.svg";
export { ForwardRef as ReactComponent };